<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"   @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
    <UPDATE  ref="uploadChildUpdate"  :updateData="uploadUpdateData" @uploadFile="uploadFile"></UPDATE>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import UPDATE from '@/components/page/update.vue'
  import Qs from 'qs'
  import URL from '@/views/newmis36/util/url'
  //0:未转 1:失败, 2:成功
  let status = {0: "未转", 1: "失败",2: "成功"};
  import DateUtil from '@/utils/IM/tradeDataUtil.js'
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
      UPDATE
    },
    methods: {
      uploadFile(col,res){
        if (res && res != '') {
          this.$message.error(res);
        }
        this.$refs.childTable.defaultGetData(this.queryData);
      },
      /*表格按钮点击事件*/
      bthClick (clickName, row) {
        if (clickName == "update"){
          this.$refs.childUpdate.open(row);
        }else if (clickName == "delete"){
          this.dataChanage(URL.realToDemo.delete,{id:row.id},res =>{
            if (res.code == 0){
              this.$message.success("suc");
            }else{
              this.$message.error(res.message);
            }
          });
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultGetData(this.queryData);
        }else if("新增" == clickName){
          this.$refs.childUpdate.open();
        }else if("导入" == clickName){
          this.$refs.uploadChildUpdate.open();
        }
      },
      /*新增或跟提交数据触发事件*/
      submit(model){
        //根据是否包含id更新还是添加
        this.dataChanage(URL.realToDemo.edit,model,res => {
          if (res.code == 0){
            this.$refs.childUpdate.close();
            this.$message.success("suc");
          }else{
            this.$message.error(res.message);
          }
      })
      },
      dataChanage(url,option,suc,fail){
        this.axios.post(url, Qs.stringify(option || {})).then(res => {
          this.$refs.childTable.defaultGetData(this.queryData);
          if(suc && (typeof suc == 'function')) suc(res);
      }).catch(res => {
          if(fail && (typeof fail == 'function')) fail(res);
      })
      }
    },
    data () {
      return {
        deleteIds:"",
        queryData:{},
        /*新增或更新*/
        updateData:{
          cols:[
            { title: 'id', field: 'id',hidden:true},
            { title: '用户账号', field: 'customer'},
            { title: '状态', field: 'status',data:0,type:2,optionList:status,isNumber:true},
          ]
        },
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
            { title: '用户账号', field: 'customer'},
            { title: '状态', field: 'status',type: 2,optionList: status,isNumber:true},
            {click:"查询"},
            {click:"新增"},
            {click:"导入"},
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: URL.realToDemo.list, //请求路径和参数
          selection: true,
          sequence: true,
          cols: [
              { title: '用户账号', field: 'customer'},
              { title: '状态', field: 'status',render:(data,full)=>{
                return status[data];
                }},
              { title: '备注', field: 'remark'},
              { title: '区号', field: 'mobilePrefix'},
              { title: '手机号', field: 'mobilePhone'},
              { title: '创建记录时间', field: 'createTime',render:(data,full)=>{
                  return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                }},
              { title: '更新记录时间', field: 'updateTime',render:(data,full)=>{
                  return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                }},
             {title:window.$t('txmis.bt.operation'),btnClick:[
                {name:window.$t('txmis.bt.edit'),click:"update",type:"primary",icon: "el-icon-edit"},
                {name:window.$t('txmis.bt.delete'),click:"delete",type:"primary",icon:"el-icon-delete"}
              ]
            },
          ]
        },
        uploadUpdateData:{
          submit: 'hidden',
          cols: [
            { title: '上传用户', field: 'mobilePhone',type:11,action:URL.realToDemo.uploadCustomer,downUrl:"https://static.chwenda.com/source/downloadModel/消息推送用户模板.xlsx"},
          ]}
      }
    }
  }
</script>
